module.exports = __webpack_public_path__ + "media/images/icon-information-33bf2669b4b29817f5b8ed67b8c13843.png";